export async function UpdateCancelCandidate(candidate) {
  const response = await fetch(
    `${process.env.REACT_APP_API}/api/candidate/cancel`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...candidate }),
    }
  );

  const data = await response.json();

  return data; // Return the response data
}
